app.service("ClinicLettersAPI", [
	"$http",
	"ENV",
	"Session",
	"Base64",
	function ($http, ENV, Session, Base64) {
		var service = {
			isProcessing: false,
			// The logged-in user's letter settings for this practice: their default sign-off (Base64 HTML)
			// and their saved handwritten signature (Base64 PNG).
			getUserSettings: function () {
				return $http({
					method: "GET",
					url: ENV.API + `/api/clinical-letter/user/${Session.user.id}/settings`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			updateUserSettings: function (data) {
				return $http({
					method: "PUT",
					url: ENV.API + `/api/clinical-letter/user/${Session.user.id}/settings`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data,
				});
			},
			startClinicLetter: function (patientId, data) {
				const fields = data.clinic_date_UTC.split("/");
				const clinic_date_UTC = moment(`${fields[2]}-${fields[1]}-${fields[0]}`, "YYYY-M-D").utc().toISOString();
				return $http({
					method: "POST",
					url: ENV.API + `/api/clinical-letter/patient/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: {...data, content: Base64.encode(data.content), clinic_date_UTC },
				});
			},
			getLetters: function (isCompleted, pageIndexes) {
					return $http({
						method: "POST",
						url: ENV.API + `/api/clinical-letter?isCompleted=${isCompleted}`,
						headers: {
							Authorization: "Bearer " + Session.token,
							"X-PRACTICE-ID": `${Session.practice.id}`,
						},
						data: pageIndexes,
					});
			},
			startTranscriptionJob: function (patientId, clinicLetterId, blob) {
				const formData = new FormData();
				formData.append("file", blob, "audio.mp3");
				return $http({
					method: "POST",
					url: ENV.API + `/api/clinical-letter/patient/${patientId}/letter/${clinicLetterId}/transcribe`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": undefined,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: formData,
					transformRequest: angular.identity,
				});
			},
			updateLetter: function (patientId, clinicLetterId, data) {
				const fields = data.clinic_date_UTC.split("/");
				const clinic_date_UTC = moment(`${fields[2]}-${fields[1]}-${fields[0]}`, "YYYY-M-D").utc().toISOString();
				return $http({
					method: "PUT",
					url: ENV.API + `/api/clinical-letter/patient/${patientId}/letter/${clinicLetterId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: {...data, content: Base64.encode(data.content), clinic_date_UTC },
				});
			},
			completeLetter: function (patientId, clinicLetterId, data, sendHL7 = true) {
				const fields = data.clinic_date_UTC.split("/");
				const clinic_date_UTC = moment(`${fields[2]}-${fields[1]}-${fields[0]}`, "YYYY-M-D").utc().toISOString();
				return $http({
					method: "POST",
					url: ENV.API + `/api/clinical-letter/patient/${patientId}/letter/${clinicLetterId}?sendHL7=${sendHL7}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: { ...data, content: Base64.encode(data.content), clinic_date_UTC },
				});
			},
			queryPatientCare: function (patientId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/patient-careteam/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			queryCatraxUsersByTerm: function (terms) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/users/search?searchTerm=${encodeURIComponent(terms || "")}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			fetchTemplate: function () {
				return $http({
					method: "GET",
					url: ENV.API + `/api/clinical-letter/templates`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			createTemplate: function (data) {
				return $http({
					method: "POST",
					url: ENV.API + `/api/clinical-letter/templates`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data
				});
			},
			deleteTemplate: function (templateId) {
				return $http({
					method: "DELETE",
					url: ENV.API + `/api/clinical-letter/templates/${templateId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			fetchTemplateById: function (templateId, practiceId){
				return $http({
					method: "GET",
					url: ENV.API + `/api/clinical-letter/templates/${templateId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${practiceId}`,
					},
				});
			},
			updateTemplate: function (templateId, data) {
				return $http({
					method: "PUT",
					url: ENV.API + `/api/clinical-letter/templates/${templateId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data,
				});
			},
			fetchClinicLetter: function (patientId, letterId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/clinical-letter/patient/${patientId}/letter/${letterId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			deleteLetter: function (patientId, letterId) {
				return $http({
					method: "DELETE",
					url: ENV.API + `/api/clinical-letter/patient/${patientId}/letter/${letterId}/archive`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			searchPracticeDirectory: function (terms) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/practice-directory?searchTerm=${encodeURIComponent(terms || "")}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			}
		};
		return service;
	},
]);
